import { useState } from "react";
import { heroCategories, hotEvents } from "@/mocks/chigua";

const statusStyle: Record<string, string> = {
  复盘完成: "bg-secondary-100 text-secondary-900",
  进行中: "bg-accent-100 text-accent-800",
  已完结: "bg-primary-100 text-primary-800",
};

export default function HotSection() {
  const [cat, setCat] = useState("全部");

  const list = cat === "全部" ? hotEvents : hotEvents.filter((e) => e.category === cat);

  return (
    <section id="hot" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 区块标题 */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mb-2">
              <span className="w-8 h-0.5 bg-primary-500 rounded-full"></span>
              最新热点复盘
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              正在发酵的事件始末
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-2xl">
              每场瓜都从起点讲起,逐条核对时间与信源,帮你理清完整时间线与前因后果。
            </p>
          </div>
          <a
            href="#media"
            className="inline-flex items-center gap-2 self-start md:self-auto px-4 py-2 rounded-md border border-background-300 text-foreground-600 text-sm whitespace-nowrap hover:bg-background-100 hover:text-primary-700 transition-colors"
          >
            查看全部栏目
            <i className="ri-arrow-right-s-line" aria-hidden="true"></i>
          </a>
        </div>

        {/* 分类筛选 */}
        <div className="flex flex-wrap items-center gap-2 mb-8">
          {heroCategories.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => setCat(c)}
              className={
                "px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors " +
                (cat === c
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-900")
              }
            >
              {c}
            </button>
          ))}
        </div>

        {/* 事件卡片 */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {list.map((e) => (
            <article
              key={e.id}
              className="group overflow-hidden rounded-xl bg-background-100 border border-background-200 flex flex-col"
            >
              <div className="relative overflow-hidden">
                <img
                  src={e.cover}
                  alt={e.title}
                  className="w-full h-48 sm:h-52 object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-xs whitespace-nowrap">
                    {e.tag}
                  </span>
                  <span
                    className={
                      "px-2.5 py-1 rounded-md text-xs whitespace-nowrap " + statusStyle[e.status]
                    }
                  >
                    {e.status}
                  </span>
                </div>
                {/* 热度条 */}
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-1 rounded-md bg-foreground-950/60 text-background-100 text-xs flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-fire-fill text-accent-400" aria-hidden="true"></i>
                    热度 {e.heat}
                  </span>
                </div>
              </div>

              <div className="p-5 flex flex-col flex-1">
                <div className="flex items-center justify-between text-xs text-foreground-500 mb-2">
                  <span className="whitespace-nowrap">{e.category}</span>
                  <span className="whitespace-nowrap">{e.published}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 leading-snug">
                  <a href="#timeline" className="hover:text-primary-600 transition-colors">
                    {e.title}
                  </a>
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
                  {e.summary}
                </p>
                <div className="mt-4 pt-3 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5 whitespace-nowrap">
                    <i className="ri-book-open-line" aria-hidden="true"></i>
                    {e.duration}
                  </span>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line" aria-hidden="true"></i>
                      {e.reads}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-chat-3-line" aria-hidden="true"></i>
                      {e.comments}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}